import { usePermissionsDialogStore } from '#auth/composables/usePermissionsDialogStore'

export default defineNuxtPlugin({
  setup(nuxtApp) {
    const { showForbiddenTeammateAction } = usePermissionsDialogStore()
    const auth = useAuth()
    nuxtApp.hooks.hook('forgd:fetch:unauthorized', async () => {
      if (!auth.isOrganizationOwner) {
        showForbiddenTeammateAction()
      }
    })
  },
})
